import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';

import { ClicksMetricService } from './clicks-metric.service';
import { IframeTrackClicksService } from './iframe-track-clicks.service';

@Component({
  selector: 'kt-clicks-metrics',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClicksMetricComponent implements OnInit {
  constructor(
    private clicksMonitoringService: ClicksMetricService,
    private iframeTrackClicksService: IframeTrackClicksService,
  ) {}

  ngOnInit(): void {
    this.iframeTrackClicksService.detectClickOnIframe();
  }

  @HostListener('document:click', [])
  private clickOnPage() {
    this.clicksMonitoringService.incrementPageClicks();
  }
}
